import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { useAuthStore } from '@/plugins/w/auth/store/auth.store'

// axios.interceptors.request.use((request) => {
// 	const authStore = useAuthStore()
// 	request.headers['Authorization'] = `Bearer ${authStore.getToken}`
// 	return request
// })

let redirectingToLogin = false

axios.interceptors.response.use(
	response => response,
	error => {
		const authStore = useAuthStore()

		const errors = [
			'Token has expired',
			'Token Signature could not be verified.',
			'Token not provided',
			'The token has been blacklisted',
			'Platnosť tokenu vypršala.'
		]

		const errorText = error?.response?.data?.error
		const status = error?.response?.status
		const requestUrl = String(error?.config?.url || '')

		// Invalidate with an already-expired token often returns 401 — ignore it.
		if (requestUrl.includes('auth/invalidate')) {
			return Promise.reject(error)
		}

		if (status === 401 && errorText === 'Unauthenticated.') {
			const handshakeActive = sessionStorage.getItem('mdx_token_handshake_active') === 'true'
			const inHostIframe = window.parent !== window
			const skipLogout = handshakeActive || (inHostIframe && !authStore.isLoggedIn)
			if (skipLogout) {
				return Promise.reject(error)
			}

			if (redirectingToLogin) {
				return Promise.reject(error)
			}
			redirectingToLogin = true

			void authStore.logout(false)
			window.location.href = `${import.meta.env.BASE_URL}prihlasenie`
			return Promise.reject(error)
		}

		if (errorText == 'user.password.change_required') {
			// authStore.logout()
			return

			// router.push({ name: 'Login - Podmienky' })
		}

		if (status === 401 && errors.includes(errorText)) {
			// authStore.logout(false)
			// window.location.reload()
			// return Promise.reject('You have been logged out')
		}

		return Promise.reject(error)
	}
)

// function refreshAuthLogic(failedRequest) {
// 	const authStore = useAuthStore()

// 	return authStore.refreshToken().then(function(token) {
// 	  failedRequest.response.config.headers.Authorization = 'Bearer ' + token;
// 	  return Promise.resolve();
// 	}).catch((error) => {
// 		return Promise.reject(error)
// 	})
// }

// createAuthRefreshInterceptor(axios, refreshAuthLogic);
